import React from "react";

function DateIcon({ strokeWidth = "1.02", w = [17], h = [17] }) {
  return (
    <svg
      width={w}
      height={h}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.66699 1.41602V3.54102"
        stroke="#424242"
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.333 1.41602V3.54102"
        stroke="#424242"
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.47949 6.43945H14.5212"
        stroke="#424242"
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.125 9.21477V6.02018C2.125 3.89518 3.1875 2.47852 5.66667 2.47852H11.3333C13.8125 2.47852 14.875 3.89518 14.875 6.02018V12.041C14.875 14.166 13.8125 15.5827 11.3333 15.5827H5.66667C3.1875 15.5827 2.125 14.166 2.125 12.041"
        stroke="#424242"
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.49676 9.70378H8.50312"
        stroke="#424242"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.87567 9.70378H5.88203"
        stroke="#424242"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.87567 11.8288H5.88203"
        stroke="#424242"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default DateIcon;
